<template>
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomSelect
          :options="this.paramOptions"
          label="Параметр"
          optionValueKey="frame_param_type_id"
          optionLabelKey="frame_param_type_name"
          :value="this.formData.frame_param_type_id"
          @change="(value) => onChange('frame_param_type_id', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" :disable-submit="validationError" />
    </q-form>
  </template>

  <script>
  import CustomModalFooter from "@/components/modal/modals/modal-footer";
  import CustomSelect from "@/components/form/CustomSelect";
  import { getParamFrameTypes } from "@/components/modal/modals/frame-type-params/services";
  
  export default {
    name: "upd-frame-type-param",
    components: { CustomSelect, CustomModalFooter },
    props: ["data"],
    data() {
      return {
        paramOptions: [],
        loading: false,
        formData: {
          frame_param_link_id: this.data?.frame_param_link_id || "",
          frame_type_id: this.data?.frame_type_id || "",
          frame_param_type_id: "",
        },
      };
    },
    methods: {
      async onChange(key, value) {
        this.formData[key] = value;
      },      
      async onSubmit() {        
        this.loading = true;
        await this.data?.onSubmit(this.formData);
        this.loading = false;
      },
      async getParams() {
        const res = await getParamFrameTypes(this.data?.frame_param_link_id);
        this.paramOptions = res || [];
      },
    },
    mounted() {
      this.getParams();
    },
  };
  </script>
  
  <style scoped lang="scss">
  .form {
    display: flex;
    flex-direction: column;
    min-width: 350px;
    gap: 20px;
  
    @media (max-width: 428px) {
      min-width: 100%;
    }
  }
  </style>
  